// Fallback
window.initMap = function(){};
const mapController = new MapController();